import React, { Component } from 'react';
import Alert from 'sweetalert-react';
import * as Business from '../../utils/business'

export default class SmartAlert extends Component {
    state = {
        isShow: false,
        title: '',
        content: '',
        onOk: null
    }

    componentDidMount() {
        Business.setAlertFunc(this.showAlert)
    }

    componentWillUnmount() {
        Business.removeAlertFunc()
    }

    showAlert = ({ title, content, onOk }) => {
        this.setState({
            title,
            content,
            onOk,
            isShow: true
        })
    }

    render() {
        return (
            <Alert
                title={this.state.title}
                show={this.state.isShow}
                text={this.state.content}
                onConfirm={() => {
                    const onOk = this.state.onOk
                    onOk && onOk()
                    this.setState({
                        title: '',
                        content: '',
                        onOk: null,
                        isShow: false
                    })
                }}
            />
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Main/SmartAlert.js